import React, { useEffect } from 'react'

import { useAuthentication } from '../../hooks/useAuthentication'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { GET_VOUCHERS, DELETE_VOUCHERS } from '../Vouchers/gql'
import { DataTable } from '../table/DataTable'
import { getDashboardColumns } from '../table/columns/dashboardColumns'
import { Container } from 'react-bootstrap'
import Loader from '../Loader'
import VoucherExpandedRow from '../table/VoucherExpandedRow'
import { toast } from 'react-toastify'

const Dashboard = () => {
  const { authState } = useAuthentication()
  const vouchers = useQuery(GET_VOUCHERS, {
    context: { headers: { authorization: authState.authToken } },
  })
  const [deleteVoucher] = useMutation(DELETE_VOUCHERS)

  const removeVoucher = async (id: string) => {
    try {
      const { data } = await deleteVoucher({ variables: { id } })
      if (data) {
        toast.success(`Voucher ${data.deleteVoucher} deleted successfully`)
        vouchers.refetch()
      }
    } catch (err: any) {
      console.error('Error updating voucher:', err.message)
      toast.error(err.message || `Voucher ${id} delete failed`)
    }
  }
  useEffect(() => {
    vouchers.refetch()
  }, [])

  if (vouchers.loading) return <Loader />
  if (vouchers.error) return <p>Error: {vouchers.error.message}</p>

  return (
    <Container fluid className="px-0">
      <h1>Dashboard</h1>
      <div style={{ overflowX: 'auto' }}>
        <DataTable
          data={vouchers.data.vouchers ?? []}
          columns={getDashboardColumns(removeVoucher)}
          renderSubComponent={(row) => (
            <VoucherExpandedRow voucher={row.original} />
          )}
        />
      </div>
    </Container>
  )
}

export default Dashboard
